import { NotificationDTO, NotificationTypes } from 'containers/notifications/types/notifications'
import { useNotificationsLikeTexts } from 'containers/notifications/hooks/notifications-texts'
import { Text } from '@/components/commons/typography/Text'
import { HeartIcon } from '@/public/assets/v2/images/icons'
import { useLikes } from 'containers/likes/hooks/useLikes'
import { useProject } from 'containers/projects/hooks/useProjects'
import { useNotificationsLikeUserInfo } from 'containers/notifications/hooks/notifications-users'
import { RequestConnectionButton } from 'containers/profile/components/buttons/RequestConnectionButton'
import Link from 'next/link'
import { getProfileLink } from 'containers/profile/utilities/profile'
import { joinWithSlash } from 'utilities/links'

interface LikeHighlightProps {
   notification: Extract<NotificationDTO, { 
    notificationType: NotificationTypes.LIKE 
  }>
}

export const LikeProject = ({ notification }: LikeHighlightProps) => {
  const { project } = useProject(notification.specificData.referencedId)
  const {likedText, ownerLikedText, likedItemText} = useNotificationsLikeTexts(notification)
  const { isLikerConnection, profileLiker } = useNotificationsLikeUserInfo(notification)
  
  const { data: likes, } = useLikes({
    surfaceType: notification.specificData.surfaceType,
    referencedId: notification.specificData.referencedId,
  })

  const titleContent = project?.title?.length > 40 ? project?.title?.slice(0, 40) + '...' : project?.title

  return (
    <div className='flex flex-column gap-14 justify-space-between'>
      <Text variation='small' weightClass='font-medium'>
        <Link href={getProfileLink(profileLiker)}>
          <span className='font-bold'>{profileLiker?.firstName} {profileLiker?.lastName}</span>{' '}
        </Link>
        {likedText}{' '}
        {ownerLikedText && <span className='font-bold'>{ownerLikedText}</span>}{' '}
        {likedItemText}{' '}
        <Link href={joinWithSlash(
          getProfileLink(profileLiker),
          'projects',
          project?.id
        )}>
          <span className='font-bold'>{titleContent}</span>
        </Link>
        {!isLikerConnection && (
          <>
            <br />
            <span>Connect with them!</span>
          </>
        )}
      </Text>

      {!isLikerConnection ? (
        <RequestConnectionButton
          profile={profileLiker}
          useViewProfile
        />
      ) : (
        <div className='flex gap-6 items-center'>
          <HeartIcon className='text-primary' />
          <Text variation='small' colorClass='text-secondary'>
            {likes?.numberOfResults} likes
          </Text>
        </div>
      )}
    </div>
  )
}
